import React, { useState, useMemo, useEffect } from "react";
import { Router } from "react-router-dom";
import history from "./services/history";
import Routes from "./router";
import Loading from "./components/_default/Loading";
import * as firebase from "./services/firebase/firebase";
import { CookiesProvider } from 'react-cookie';
import { getUserById } from "./services/firebase/firestore/getData";
import { doSignOut } from "./services/firebase/auth";
import { UserProvider } from './services/context/userContext'
import { createFormTest } from "./services/firebase/firestore/saveData";


function App(props) {
  const [authUser, setAuthUser] = useState(null);
  const [user, setUser] = useState(false);

  useEffect(() => {
    createFormTest()
  },[])

  useMemo(() => {
    firebase.auth.onAuthStateChanged((user) => {
      if (user) {
        getUserById(user.uid, (result) => {
          if (result) {
            setUser(result);
            setAuthUser(true);
          } else {
            setUser({ error: true, message: "Your account doesn't have access to this platform." });
            doSignOut();
          }
        });
      } else {
        setAuthUser(false);
      }
    });
  }, [authUser]);

  return (
    <CookiesProvider>
      <UserProvider value={user}>
        <Router history={history}>
          {authUser !== null ? (
            <Routes signed={authUser} />
          ) : (
            <div className="app-wrapp">
              <Loading />
            </div>
          )}
        </Router>
      </UserProvider>
    </CookiesProvider>
  );
}

export default App;
